import React from 'react';
import '../styles/BloodBankCard.css';

const BloodBankCard = ({ bloodBank }) => {
    const renderStars = (rating) => {
        const stars = [];
        const fullStars = Math.floor(rating);
        const hasHalfStar = rating % 1 >= 0.5;
        
        for (let i = 0; i < fullStars; i++) {
            stars.push(<span key={i} className="star filled">★</span>);
        }
        
        if (hasHalfStar) {
            stars.push(<span key="half" className="star half">☆</span>);
        }
        
        const emptyStars = 5 - fullStars - (hasHalfStar ? 1 : 0);
        for (let i = 0; i < emptyStars; i++) {
            stars.push(<span key={`empty-${i}`} className="star">☆</span>);
        }
        
        return stars;
    };

    const getBloodGroupAvailability = (bloodGroups) => {
        if (bloodGroups.length === 8) {
            return "All Blood Groups Available";
        } else if (bloodGroups.length >= 6) {
            return "Most Blood Groups Available";
        } else if (bloodGroups.length >= 4) {
            return "Limited Blood Groups Available";
        } else {
            return "Few Blood Groups Available";
        }
    };

    const getAvailabilityClass = (bloodGroups) => {
        if (bloodGroups.length >= 6) return "high-availability";
        if (bloodGroups.length >= 4) return "medium-availability";
        return "low-availability";
    };

    const calculateDistance = () => {
        // Mock distance calculation - in real app, this would use actual location data
        return `${Math.floor(Math.random() * 25 + 1)} km`;
    };

    return (
        <div className="bb-bloodbank-card">
            <div className="bb-docentresult">
                <div className="bb-docentinfo">
                    <div className="bb-docinfo">
                        <div className="bb-advance-search-tools bb-flex">
                            <div className="bb-title">
                                <h3>
                                    <span className="bb-bloodbank-name">{bloodBank.name}</span>
                                    {bloodBank.isEmergency && (
                                        <span className="bb-emergency-badge">🚨 Emergency 24/7</span>
                                    )}
                                </h3>
                                <div className="bb-locationinfo">
                                    <i className="fa fa-map-marker"></i>
                                    <span className="bb-bloodbank-location">{bloodBank.location}</span>
                                </div>
                                <div className="bb-bloodbank-address">{bloodBank.address}</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bb-specialitys">
                    <div className="bb-services">
                        <h4>Available Services</h4>
                        <div className="bb-services-list">
                            {bloodBank.services.slice(0, 4).map((service, index) => (
                                <span key={index} className="bb-service-tag">{service}</span>
                            ))}
                            {bloodBank.services.length > 4 && (
                                <span className="bb-more-services">+{bloodBank.services.length - 4} more</span>
                            )}
                        </div>
                    </div>

                    <div className="bb-blood-bank-details">
                        <div className="bb-contact-info">
                            <div className="bb-contact-item">
                                <i className="fa fa-phone"></i>
                                <span>{bloodBank.phone}</span>
                            </div>
                            <div className="bb-contact-item">
                                <i className="fa fa-envelope"></i>
                                <span>{bloodBank.email}</span>
                            </div>
                            <div className="bb-contact-item">
                                <i className="fa fa-clock-o"></i>
                                <span>{bloodBank.hours}</span>
                            </div>
                        </div>

                        <div className="bb-blood-availability">
                            <div className={`bb-availability-status ${getAvailabilityClass(bloodBank.bloodGroups)}`}>
                                <span className="bb-availability-icon">🩸</span>
                                <span className="bb-availability-text">
                                    {getBloodGroupAvailability(bloodBank.bloodGroups)}
                                </span>
                            </div>
                            
                            <div className="bb-blood-groups">
                                <span className="bb-blood-groups-label">Available Groups:</span>
                                <div className="bb-blood-group-tags">
                                    {bloodBank.bloodGroups.map((group, index) => (
                                        <span key={index} className={`bb-blood-group-tag ${group.toLowerCase().replace('+', 'pos').replace('-', 'neg')}`}>
                                            {group}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bb-resultfoot">
                    <div className="bb-rateinfo">
                        <div className="bb-rating-section">
                            <div className="bb-stars">
                                {renderStars(bloodBank.rating)}
                                <span className="bb-rating-number">({bloodBank.reviews} reviews)</span>
                            </div>
                        </div>
                        
                        <div className="bb-distance-info">
                            <i className="fa fa-map-signs"></i>
                            <span>{calculateDistance()} away</span>
                        </div>

                        <div className="bb-blood-bank-badges">
                            {bloodBank.isEmergency && (
                                <span className="bb-badge bb-emergency">Emergency Available</span>
                            )}
                            <span className="bb-badge bb-verified">✓ Verified</span>
                            <span className="bb-badge bb-quality">Quality Certified</span>
                        </div>
                    </div>

                    <div className="bb-searchresults">
                        <button 
                            className="bb-btn-secondary bb-btn-call"
                            onClick={() => window.open(`tel:${bloodBank.phone}`, '_self')}
                        >
                            <i className="fa fa-phone"></i> Call Now
                        </button>
                        
                        <button 
                            className="bb-btn-primary bb-btn-details"
                            onClick={() => {
                                // Navigate to blood bank details page
                                window.location.href = `/blood-bank/${bloodBank.id}/${bloodBank.name.toLowerCase().replace(/\s+/g, '-')}`;
                            }}
                        >
                            <i className="fa fa-info-circle"></i> View Details
                        </button>
                        
                        <button 
                            className="bb-btn-success bb-btn-directions"
                            onClick={() => {
                                // Open directions in maps
                                const mapsUrl = `https://maps.google.com/?q=${bloodBank.lat},${ bloodBank.lng}`;
                                window.open(mapsUrl, '_blank');
                            }}
                        >
                            <i className="fa fa-map-marker"></i> Directions
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default BloodBankCard;

